import React from "react";
import { Baixar } from "../../comum/components/Icones";
import { observer } from "mobx-react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Spinner
} from "reactstrap";

const ModalDocumentos = observer(({ controller }) => {
  const { modalDocumentosAberto, fecharModalDocumentos, anexos, loadingDocumentos } = controller;

  const formatarData = (valor) => {
    if (!valor) return "";
    // Se já vier formatado do backend, retorna direto
    if (valor.includes("/") && valor.includes(":")) return valor;
    // Se vier em formato ISO, converte
    const data = new Date(valor);
    return isNaN(data.getTime()) ? valor : data.toLocaleString("pt-BR");
  };

  return (
    <Modal isOpen={modalDocumentosAberto} toggle={fecharModalDocumentos} size="lg">
      <ModalHeader toggle={fecharModalDocumentos}>
        Documentos Anexados
      </ModalHeader>
      <ModalBody>
        {loadingDocumentos ? (
          <div className="text-center my-4">
            <Spinner color="primary" /> <p>Carregando documentos...</p>
          </div>
        ) : anexos.length === 0 ? (
          <p className="text-center text-muted">Nenhum documento encontrado.</p>
        ) : (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Descrição</th>
                <th>Data Upload</th>
                <th style={{ width: "100px", textAlign: "center" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {anexos.map((a) => (
                <tr key={a.Id || a.anexoId}>
                  <td>{a.NomeArquivo || a.nomeArquivo || "-"}</td>
                  <td>{a.Descricao || a.descricao || "-"}</td>
                  <td>{formatarData(a.DataUpload || a.dataUpload)}</td>
                  <td style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      size="sm"
                      title="Baixar"
                      onClick={() => controller.baixarAnexo(a)}
                    >
                      <Baixar tamanho="sm" cor="#617080" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={fecharModalDocumentos}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
});

export default ModalDocumentos;



// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/components/ModalDocumentos.js